export default "__VITE_ASSET__BGX4uwkV__"